import React from 'react'

import { Station } from '../../../core/stations'
import { strings } from './emergencies-content'
import styles from '../../styles/modules/emergencies/emergencies-query.module.scss'

interface Props {
  options: Station[]
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  value: string
  disabled?: boolean
  isLoading?: boolean
}

const QueryStation: React.FC<Props> = props => {
  const hasStations = props.options.length > 0
  const disabled = props.disabled || props.isLoading || !hasStations
  const placeholder = props.isLoading
    ? strings.loadingStations
    : hasStations
    ? strings.queryPlaceHolder
    : strings.noStations
  return (
    <div className={styles.container}>
      <span className={styles.title}>{strings.queryStationTitle}</span>
      <div className={styles.stationsWrapper}>
        <select
          disabled={disabled}
          className={styles.input}
          value={hasStations ? props.value : '@all'}
          onChange={event => props.onChange(event)}
        >
          <option value={'@all'}>{placeholder}</option>
          {props.options.map(item => (
            <option value={item.id} key={item.id}>
              {`ID: ${item.id} ${item.name}`}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default QueryStation
